import { ITaskProgressInformation } from '@Data/processes/Interfaces';
import { error } from '@Services/notification/NotificationServices';
import { NotificationSeverity, ProgressState } from './Interfaces';

export function getNotificationSeverity(
    severityStr: string
): NotificationSeverity {
    switch (severityStr) {
        case 'warning':
            return NotificationSeverity.WARNING;
        case 'error':
            return NotificationSeverity.ERROR;
        case 'success':
            return NotificationSeverity.SUCCESS;
        case 'info':
            return NotificationSeverity.INFO;
        default:
            error('incorrect notification severity string detected');
            throw null;
    }
}

export function getNotificationSeverityString(
    severity: NotificationSeverity
): string {
    switch (severity) {
        case NotificationSeverity.WARNING:
            return 'warning';
        case NotificationSeverity.ERROR:
            return 'error';
        case NotificationSeverity.SUCCESS:
            return 'success';
        case NotificationSeverity.INFO:
            return 'info';
    }
}

export function getRemainingTimeString(
    progressInfo: ITaskProgressInformation
): string {
    if (progressInfo.etc) {
        let output = '';
        const timeInSeconds = +parseFloat(progressInfo.etc).toFixed(0);
        const getSecondsStr = (timeInSeconds) => {
            return timeInSeconds > 1 ? 'seconds' : 'second';
        };
        if (timeInSeconds < 60) {
            output = `${timeInSeconds} ${getSecondsStr(timeInSeconds)}`;
        } else {
            const minutes = Math.floor(timeInSeconds / 60);
            const seconds = timeInSeconds - minutes * 60;
            output = `${minutes} minute${
                minutes > 0 ? 's' : ''
            }, ${seconds} ${getSecondsStr(timeInSeconds)}`;
        }
        return `~ ${output} remaining`;
    }
    return 'pending';
}

export function getProgressStateFromString(
    progressString: string
): ProgressState {
    switch (progressString.toLowerCase().trim()) {
        case 'progress':
        case 'pending':
            return ProgressState.PENDING;
        case 'success':
            return ProgressState.SUCCESS;
        case 'failure':
            return ProgressState.FAILURE;
    }
}

export function getRawProcessName(name: string): string {
    return name.split(' progress')[0];
}
